import React from 'react';
import clsx from 'clsx';
import { IStatus } from '@/components/staffer/Scores/GradesTable/types';
import GradeCellSkeleton from './GradeCellSkeleton';
import styles from './GradesCells.module.scss';

interface GradeCellProps {
  id: string,
  isLoading?: boolean,
  label?: string,
  status: IStatus,
  updatedSinceGraded?: boolean,
  url: string,
}

const GradeCell = ({ id, isLoading = false, label, status, updatedSinceGraded, url }: GradeCellProps) => {
  if (isLoading) return <GradeCellSkeleton />;

  return (
    <div className={clsx(`tw-flex tw-flex-col tw-justify-center tw-w-full tw-h-full ${status.color}`)}>
      <a aria-label={label} className={status.color} href={url} id={id}>
        {status.text}
      </a>
      {updatedSinceGraded && <span className={styles.updatedSinceGraded}>Updated!</span>}
    </div>
  );
};

export default GradeCell;
